import { render, staticRenderFns } from "./SubTask.vue?vue&type=template&id=41cafce6"
import script from "./SubTask.vue?vue&type=script&lang=js"
export * from "./SubTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports